/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies
 */
import {
    getColorClassName,
    getColorObjectByAttributeValues,
    __experimentalGetGradientClass,
} from '@wordpress/block-editor';

// The code in this file is copied entirely from the "color" and "style" support flags
// The flag can't be used at the moment because of the extra wrapper around
// the button block markup.
export default function getColorAndStyleProps(
    attributes,
    colors,
    isEdit = false
) {
    // I'd have prefered to avoid the "style" attribute usage here
    const { backgroundColor, textColor, gradient, style, className, backgroundHover, textHover, duration } = attributes;
    const backgroundClass = getColorClassName(
        'background-color',
        className === 'is-style-fill' ? backgroundColor : 'none'
    );
    const gradientClass = __experimentalGetGradientClass( gradient );
    const textClass = getColorClassName( 'color', textColor );
    const innerClassName = classnames( textClass, gradientClass, {
        // Don't apply the background class if there's a custom gradient
        [ backgroundClass ]: ! style?.color?.gradient && !! backgroundClass,
        'has-text-color': textColor || style?.color?.text,
        'has-background':
            backgroundColor ||
            style?.color?.background ||
            gradient ||
            style?.color?.gradient,
    } );
    const styleProp =
        style?.color?.background || style?.color?.text || style?.color?.gradient
            ? {
                background: style?.color?.gradient // if gradient
                    ? style.color.gradient
                    : style?.color?.background // otherwise if just color
                    ? style.color.background
                    : undefined, // else
                color: style?.color?.text ? style.color.text : undefined,
            }
            : {};

    if (className === 'is-style-fill') {
        styleProp['--background-hover'] = backgroundHover;
        styleProp['--border-hover'] = 'transparent';
        styleProp['--text-hover'] = textHover;
    }
    else if (className === 'is-style-outline') {
        styleProp['--background-hover'] = 'transparent';
        styleProp['--border-hover'] = backgroundHover;
        styleProp['--text-hover'] = textHover;
    }
    else {
        styleProp['--background-hover'] = 'transparent';
        styleProp['--border-hover'] = 'transparent';
        styleProp['--text-hover'] = textHover;
    }

    styleProp['--transition-duration'] = duration + 'ms';

    // This is needed only for themes that don't load their color stylesheets in the editor
    // We force an inline style to apply the color.\
    if (isEdit) {
        if ( backgroundColor ) {
            const backgroundColorObject = getColorObjectByAttributeValues(
                colors,
                backgroundColor
            );

            if (className === 'is-style-fill') {
                styleProp.background = backgroundColorObject.color;
                styleProp.borderColor = backgroundColorObject.color;
            }
            else if (className === 'is-style-outline') {
                styleProp.borderColor = backgroundColorObject.color;
                styleProp.background = 'transparent';
            }
            else {
                styleProp.borderColor = 'transparent';
                styleProp.background = 'transparent';
            }
        }

        if ( textColor ) {
            const textColorObject = getColorObjectByAttributeValues(
                colors,
                textColor
            );

            styleProp.color = textColorObject.color;
        }
    }

    return {
        className: !! innerClassName ? innerClassName : undefined,
        style: styleProp,
    };
}